export default () => {
  function scrollToElementFromUrlParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const elementId = urlParams.get("scrollTo");

    if (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        console.warn(`Element with ID '${elementId}' not found.`);
      }
    }
  }

  // Call the function when the DOM is fully loaded
  document.addEventListener("DOMContentLoaded", scrollToElementFromUrlParam);
};
